<template>
  <div class="min-h-screen bg-stone-100 flex flex-col items-center py-12 px-4 sm:px-6">
    <img class="max-h-14 w-auto mb-8" src="/images/logo-bp-noclaim.png" alt="Brainspro">

    <div class="w-full max-w-2xl bg-white rounded-lg shadow px-6 py-8 sm:px-10">
      <h1 class="text-xl font-bold text-gray-700 text-center">
        {{ $t('login.select_academy_title') }}
      </h1>
      <p class="mt-2 text-sm text-gray-500 text-center">
        {{ $t('login.select_academy_subtitle') }}
      </p>

      <div v-if="loading" class="py-12 text-center text-gray-400 text-sm">
        {{ $t('login.select_academy_loading') }}
      </div>

      <ul v-else class="mt-6 divide-y divide-gray-200">
        <li
          v-for="academy in academies"
          :key="academy.uuid"
          class="flex items-center justify-between py-4"
        >
          <div class="flex items-center min-w-0">
            <div
              v-if="academy.branding && academy.branding.logo_url"
              class="flex-shrink-0 h-10 w-10 mr-3"
            >
              <img
                class="h-10 w-10 rounded-full object-cover"
                :src="academy.branding.logo_url"
                :alt="academy.title"
              />
            </div>
            <div
              v-else
              class="flex-shrink-0 h-10 w-10 mr-3 bg-bpblue rounded-full flex items-center justify-center"
            >
              <span class="text-white text-sm font-bold">{{
                academy.title ? academy.title.charAt(0).toUpperCase() : "A"
              }}</span>
            </div>
            <div class="min-w-0">
              <div class="text-sm font-medium text-gray-900 truncate">
                {{ academy.title }}
              </div>
              <div class="text-xs text-gray-400 truncate">
                {{ academy.subdomain }}
              </div>
            </div>
          </div>

          <button
            type="button"
            @click="selectAcademy(academy.uuid)"
            class="ml-4 flex-shrink-0 inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium rounded-md text-white bg-bpblue hover:bg-blue-500 transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-bpblue"
          >
            {{ $t('login.select_academy_action') }}
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import AcademyService from "@/services/academy/AcademyService";
import NotificationService from "@/services/notification/NotificationService";
import {useAuthUserStore} from "@/stores/auth";

export default {
  name: "SelectAcademyComponent",
  setup() {
    const authUserStore = useAuthUserStore()
    return { authUserStore }
  },
  data() {
    return {
      academies: [],
      loading: true,
    };
  },
  created() {
    this.getAcademies();
  },
  methods: {
    selectAcademy(academyUuid) {
      this.authUserStore.selectAcademy(academyUuid)
    },
    getAcademies() {
      this.loading = true;
      AcademyService.index()
        .then((response) => {
          this.academies = response.data ?? [];
        })
        .catch((error) => {
          console.log("Error al obtener las academias", error);
          NotificationService.showNotification(
            "Ha ocurrido un error inesperado",
            "error"
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped></style>
